module.exports = __webpack_public_path__ + "static/media/Key.f5f02a9f.svg";